import {
  RecommendedDirectDebitResponse,
  useRecommendedDirectDebitLegacyQuery,
} from '@ovotech/energy-cx';
import { QueryResultRenderer, useAccountContext } from '@ovotech/ui-tools';

import React from 'react';
import { StruggleToPay } from '../../ChangeDirectDebitAmount/StruggleToPay';
import OneClickPaymentReduction from './OneClickPaymentReduction';
import { isValidRecommendedDirectDebit } from './utils';

const Data = ({
  data: [recommendedDirectDebit],
}: {
  data: readonly [RecommendedDirectDebitResponse];
}) => {
  return isValidRecommendedDirectDebit(recommendedDirectDebit) ? (
    <OneClickPaymentReduction />
  ) : (
    <StruggleToPay />
  );
};

const OneClickPaymentAmountQuery = ({ accountId }: { accountId: string }) => {
  const recommendedDirectDebitQueryResult =
    useRecommendedDirectDebitLegacyQuery(accountId);

  return (
    <QueryResultRenderer
      queryResults={[recommendedDirectDebitQueryResult] as const}
      NoData={() => null}
      Error={() => <StruggleToPay />}
      Data={Data}
    />
  );
};

export const OneClickPaymentReductionMain = () => {
  const { accountId } = useAccountContext();

  if (accountId == null) {
    return null;
  }

  return <OneClickPaymentAmountQuery accountId={accountId} />;
};
